import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AiInstructionEditModal = ({
  open,
  description,
  value = '',
  onChange,
  onClose,
  onSave,
  isSaving = false,
}) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
    <DialogTitle sx={{ fontWeight: 700, pr: 6 }}>
      Edit instructions
      <IconButton onClick={onClose} aria-label='Close' sx={{ position: 'absolute', right: 8, top: 8 }}>
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent sx={{ pt: '12px !important' }}>
      <Typography variant='body2' color='text.secondary' mb={2}>
        {description}
      </Typography>
      <TextField
        value={value}
        onChange={(event) => onChange(event.target.value)}
        fullWidth
        multiline
        minRows={12}
        sx={{
          '& .MuiInputBase-input': {
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
            fontSize: 13,
            lineHeight: 1.6,
          },
        }}
      />
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onClose} sx={{ textTransform: 'none' }}>
        Cancel
      </Button>
      <Button variant='contained' onClick={onSave} disabled={isSaving} sx={{ textTransform: 'none' }}>
        {isSaving ? 'Saving…' : 'Save'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default AiInstructionEditModal;
